import animation from '@helpers/animation';
import brand from '@helpers/brand';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Overlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  background-color: rgba(0, 0, 0, 0.6);
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  padding: 58px 0;
  place-content: center;
  place-items: center;
  z-index: ${Layers.Modal};
  transition: opacity 1s ${animation.secondary};
  opacity: 0;

  @media ${from(Device.TabletLarge)} {
    padding: 58px;
  }

  &.ReactModal__Overlay--after-open {
    opacity: 1;
  }

  &[data-seamless='true'] {
    padding: 0;
  }
`;
const Content = styled.div `
  position: relative;
  display: block;
  background-color: ${brand.white};
  height: 100%;
  max-height: 100%;
  max-width: 1440px;
  min-height: 0;
  min-width: 0;
  outline: none;
  width: 100%;

  [data-seamless='true'] & {
    max-width: none;
  }
`;
const ModalStyles = {
    Content,
    Overlay,
};
export default ModalStyles;
